import './index.css';

import App from './App';
import { RecoilRoot } from 'recoil';
import ReactDOM from 'react-dom/client';

const app = (
    <RecoilRoot>
        <App />
    </RecoilRoot>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(app);
